import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  MainContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 60,
    width: '100%',
    zIndex: -6,
  },
  OrderSection: {
    padding: '20px 12px 120px',
    width: '100%',
  },
  MainHeading: {
    textAlign: 'center',
    color: theme.colors.light.freshPowder,
    fontSize: theme.fonts.sizes.font18PX,
    fontFamily: theme.fonts.family.primary,
    marginBottom: 10,
    fontWeight: 900,
  },
  Divider: {
    height: 1,
    border: 'none',
    display: 'flex',
    backgroundColor: theme.colors.dark.steelBlue,
    marginBottom: 20,
  },
}));

export const useStylesPayButton = makeStyles(theme => ({
  root: {
    width: 110,
    height: 40,
    backgroundColor: theme.colors.orange.orange,
    color: theme.colors.light.freshPowder,
    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
      color: theme.colors.light.freshPowder,
    },
  },
}));
